import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { BehaviorSubject, Observable } from 'rxjs';

import { WindowRef } from '@finder/shared/services/window-ref/window-ref.service';

@Injectable({
    providedIn: 'root',
})
export class HashTriggerableService {
    private activeId = new BehaviorSubject<string>(void 0);
    private currentElementId: string;
    private eventTrigger = false;

    private get windowLocation() {
        return this.window.nativeWindow.location;
    }

    get isTriggered() {
        return this.eventTrigger;
    }

    constructor(
        private location: Location,
        private window: WindowRef,
    ) { }

    getActiveElementId(): Observable<string> {
        return this.activeId.asObservable();
    }

    setActiveElementId(elementId): void {
        if (this.currentElementId === elementId) {
            return;
        }

        this.currentElementId = elementId;
        this.activeId.next(elementId);
    }

    updateHash(hash: string, prefix?: string) {
        const urlHash = prefix ? `${prefix}-${hash}` : hash;

        // We don't need to do anything if the hash matches
        if (this.windowLocation.hash === `#${urlHash}`) {
            return;
        }

        this.location.go(
            `${this.windowLocation.pathname}/`.replace(/\/{2,}$/, '/') +
            `${this.windowLocation.search}#${urlHash}`
        );
        this.setActiveElementId(urlHash);
    }

    removeHash() {
        if (!this.windowLocation.hash) {
            return;
        }

        this.location.go(
            `${this.windowLocation.pathname}/`.replace(/\/{2,}$/, '/') +
            this.windowLocation.search
        );
        this.setActiveElementId(null);
    }

    enableTrigger() {
        this.eventTrigger = true;
    }

    disableTrigger() {
        this.eventTrigger = false;
    }
}
